import * as React from "react";
import { widgetDefinition } from "views/logic/Widgets";
const CustomExportSettings = ({ widget }) => {
  var _a;
  const { exportComponent: ExportComponent = () => null } = (_a = (widget == null ? void 0 : widget.type) && widgetDefinition(widget.type)) != null ? _a : {};
  return /* @__PURE__ */ React.createElement(ExportComponent, { widget });
};
export default CustomExportSettings;
